import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { MessageRefreshPage } from '@core/constants/messages';
import { MessageService } from 'primeng/api';
import { Observable, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { AssessmentService } from '../service/assessment.service';

@Injectable({
  providedIn: 'root'
})
/* Possibly we can find a better solution and will remove this guard. */
export class AccessDataPreviewGuard {
  constructor(
    private readonly assessmentService: AssessmentService,
    private readonly messageService: MessageService
  ) { }

  canActivate(next: ActivatedRouteSnapshot): Observable<boolean> {
    const referralId = next.params['rId'];
    const queryString = `?$top=10&$skip=0&$filter=referralId eq ${referralId}`;
    const getReferrals$ = combineLatest([
      this.assessmentService.getReferrals(queryString),
      this.assessmentService.getArchivedReferrals(queryString),
    ]);

    return getReferrals$.pipe(
      map(([referrals, archivedReferrals]) => {
        if (referrals.items.length) {
          // pass referral data to component by route data, to prevent dublicated call in resolver
          next.data = { ...next.data, referral: referrals.items[0] }
          return true;
        }
        if (archivedReferrals.items.length) {
          // pass referral data to component by route data, to prevent dublicated call in resolver
          next.data = { ...next.data, referral: archivedReferrals.items[0] }
          return true;
        }
        this.messageService.add({
          key: 'sdohToastMessage',
          severity: 'warn',
          summary: 'Warning',
          detail: MessageRefreshPage,
          life: 5000
        });
        return false;
      })
    );
  }
}
